<template>
  <el-form-item style="text-align: center" class="actionWrapper">
    <el-button type="warning" v-if="updated" autofocus @click="submitForm">{{ $t("atualizar")
    }}</el-button>
    <el-button type="warning" v-else autofocus @click="submitForm">{{ $t("adicionar")
    }}</el-button>
    <el-button @click="back()">{{ $t("voltar") }}</el-button>
  </el-form-item>
</template>
<script>

export default {
  name: "ShippingAddFormFooter",
  props: ['updated', 'redirect'],
  methods: {
    submitForm() {
      this.$emit("submit");
    },
    back() {
      this.$router.push({ name: this.redirect });
    },
  }
};
</script>
